<div mat-dialog-content>
<div class="col-md-12 row">
    <div class="col-md-12"></div>
</div>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
</div>
